


























import { Vue, Prop, Component } from "vue-property-decorator";
import DatePicker from "vue2-datepicker";
import Trip from "app/shared/models/trip.model";
import moment from "moment";
import store from '../../../store';

@Component({
  components: { DatePicker }
})
export default class DatePickerComponent extends Vue {
  @Prop() private placeholder: string;
  @Prop() private trip!: Trip;
  @Prop() private selectDate!: Function;
  @Prop() private passengerId!: number;
  @Prop() private passengerType!: string;
  @Prop() private trips!: Array<Trip>;
  @Prop() private propsSelectedDate: string;

  public selectedDate = "";
  public notBeforeDate = moment(new Date(), "DD-MMM-YYYY");
  public date = moment(new Date(), "DD-MMM-YYYY");
  public afterDate = this.date.set("d", this.notBeforeDate.get("d") + 330);
  public notAfterDate = this.date.set("d", this.notBeforeDate.get("d") + 36000);

  constructor() {
    super();
    this.date = moment(new Date(), "DD-MMM-YYYY");
    this.afterDate = this.date.set("d", this.notBeforeDate.get("d") + 335);

    if (this.trip) {
      this.notAfterDate = moment(new Date(), "DD-MMM-YYYY").add(334, "day");
      this.selectedDate = "" || this.trip.date;

      if (this.trips[this.trip.id - 1]) {
        this.notBeforeDate = moment(
          this.trips[this.trip.id - 1].date,
          "DD-MMM-YYYY"
        ).add(1, "day");
      } else {
        this.notBeforeDate = moment(new Date(), "DD-MMM-YYYY");
      }
    } else {
      const firstFlightDate = this.getFirstFlightDate();
      let yearsCutoff = this.getYearSelectionCutoff( this.passengerType );
      if( this.passengerType !== 'I' ){
          this.notAfterDate = moment(firstFlightDate, 'DD-MMM-YYYY').add(-1 * yearsCutoff.notAfter, 'years');
      }else{
          this.notAfterDate = moment(new Date(), "DD-MMM-YYYY");
      }
      this.notBeforeDate = moment(firstFlightDate, 'DD-MMM-YYYY').add(-1 * yearsCutoff.notBefore, 'years');
    }

    if (
      moment(this.selectedDate, "DD-MMM-YYYY").format("YYYY") ===
      moment(new Date(), "DD-MMM-YYYY")
        .add(100, "years")
        .format("YYYY")
    ) {
      this.selectedDate = moment(this.selectedDate, "DD-MMM-YYYY")
        .add(-100, "years")
        .format("DD-MMM-YYYY");
    }

  }

  private getYearSelectionCutoff(passengerType: string){
    let cutoff: any = {};
    if (passengerType === 'I') {
      cutoff.notAfter = 0;
      cutoff.notBefore = 2;
    } else if (passengerType === 'C') {
      cutoff.notAfter = 2;
      cutoff.notBefore = 12;
    } else {
      cutoff.notAfter = 12;
      cutoff.notBefore = 120;
    }

    return cutoff;
  }

  private getFirstFlightDate(){
    const months: any = {
      'Jan' : '00',
      'Feb' : '01',
      'Mar' : '02',
      'Apr' : '03',
      'May' : '04',
      'Jun' : '05',
      'Jul' : '06',
      'Aug' : '07',
      'Sep' : '08',
      'Oct' : '09',
      'Nov' : '10',
      'Dec' : '11'
    }
    let datePieces:any[] = store.state.selectedSegments[0].departure_date.split(' ')[1].split('-');
    return new Date(datePieces[2], months[datePieces[1]], datePieces[0]);
  }

  private dateRestriction(selectedDate: string) {
    const date = moment(selectedDate, "DD-MMM-YYYY");

    if (this.selectedDate) {
      const convertedDate = moment(date).format("DD-MMM-YYYY");
      this.selectedDate = convertedDate;
      if (this.trip) {
        this.selectDate(this.trip, convertedDate);
      } else {
        this.selectDate(convertedDate, this.passengerId);
      }
    }
  }
}
